export interface ILocation {
  id: string;
  planType: string,
  clientId: string;
  client: {
    name: string;
  };
  code?: string;
  name: string;
  streetName: string;
  streetNumber: string;
  floorNumber?: string;
  houseNumber?: string;
  phone: string;
  email: string;
  city: string;
  postalCode: string;
  latitude: string;
  longitude: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  automaticApproval:boolean
}

export interface ILocationRes {
  data: ILocation;
}

export interface ILocationsRes {
  data: ILocation[];
  count: number;
}

export interface ILocationFormValues {
  planType: string,
  clientId: string;
  name: string;
  streetName: string;
  streetNumber: string;
  phone: string;
  email: string;
  city: string;
  postalCode: string;
  floorNumber?: string;
  houseNumber?: string;
  automaticApproval?: boolean;
}

export enum PlanType {
  Free = "Free",
  Standard = "Standard",
  Premium = "Premium"
};
export enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Delete = "Delete",
}